import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, FORMAT_TEXT_COMMAND, RangeSelection } from 'lexical';
import React from 'react';
import {
  BsPaperclip,
  BsTypeBold,
  BsTypeItalic,
  BsTypeUnderline,
} from 'react-icons/bs';

type ToolBarEditProps = {
  typeBold: boolean;
  typeItalic: boolean;
  typeUnderline: boolean;
  setTypeBold: (value: boolean) => void;
  setTypeItalic: (value: boolean) => void;
  setTypeUnderline: (value: boolean) => void;
  inputFile: React.RefObject<HTMLInputElement>;
};

const ToolBarEdit: React.FC<ToolBarEditProps> = ({
  typeBold,
  typeItalic,
  typeUnderline,
  setTypeBold,
  setTypeItalic,
  setTypeUnderline,
  inputFile,
}: {
  typeBold: boolean;
  typeItalic: boolean;
  typeUnderline: boolean;
  setTypeBold: (value: boolean) => void;
  setTypeItalic: (value: boolean) => void;
  setTypeUnderline: (value: boolean) => void;
  inputFile: React.RefObject<HTMLInputElement>;
}) => {
  const [editor] = useLexicalComposerContext();

  editor.update(() => {
    const selection = $getSelection() as RangeSelection | null;

    if (selection === null) return;
    setTypeBold(selection?.hasFormat('bold'));
    setTypeItalic(selection?.hasFormat('italic'));
    setTypeUnderline(selection?.hasFormat('underline'));
  });

  const onClickBold = (e: React.MouseEvent): void => {
    editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold');
  };

  const onClickItalic = (e: React.MouseEvent): void => {
    editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic');
  };

  const onClickUnderline = (e: React.MouseEvent): void => {
    editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline');
  };

  return (
    <div style={{ background: 'transparent' }}>
      <button
        className={`button-text ${typeBold ? 'button-text-active' : ''}`}
        type="button"
        onClick={onClickBold}
      >
        <BsTypeBold size={17} className="text-black" />
      </button>
      <button
        className={`button-text ${typeItalic ? 'button-text-active' : ''}`}
        type="button"
        onClick={onClickItalic}
      >
        <BsTypeItalic size={17} className="text-black" />
      </button>
      <button
        className={`button-text ${typeUnderline ? 'button-text-active' : ''}`}
        type="button"
        onClick={onClickUnderline}
      >
        <BsTypeUnderline size={17} className="text-black" />
      </button>

      <button
        className="button-text "
        type="button"
        onClick={() => inputFile.current?.click()}
      >
        <BsPaperclip size={17} className="text-black" />
      </button>
    </div>
  );
};

export default ToolBarEdit;
